import { useOfferPageContext } from 'pages/offer/context';
import { ActionButtonType, CardVariant } from '../types';
import { Typography, TypographyType, TypographyColor } from './typography';
import { Spacing, SpacingSize, SpacingDirection } from './spacing';
import styles from './head-banner.module.scss';
import { ButtonVariant } from './button';
import { Card, ActionButton } from '.';

/**
 * Head banner with offer
 */
export const HeadBanner = () => {
  const {
    userData: { fullName, actionEnds },
    accept,
    reject,
    step,
    formattedSelectedDate,
  } = useOfferPageContext();

  return (
    <Card variant={CardVariant.benefit} className={styles.headBanner}>
      <Spacing size={SpacingSize.medium} direction={SpacingDirection.vertical} className={styles.rowsSpacing}>
        <Typography type={TypographyType.h1} color={TypographyColor.white} className={styles.offer}>
          Предложение о работе
        </Typography>

        {step !== 'accepted' && step !== 'rejected' && (
          <>
            <Typography type={TypographyType.h4} color={TypographyColor.white} className={styles.userRequest}>
              {fullName}, присоединяйся к команде
            </Typography>

            <Spacing className={styles.buttonsBlock} direction={SpacingDirection.both} size={SpacingSize.small}>
              <ActionButton onClick={accept} action={ActionButtonType.accept} />
              <ActionButton onClick={reject} action={ActionButtonType.decline} variant={ButtonVariant.secondary} />
            </Spacing>

            <Typography className={styles.endDate} type={TypographyType.h5} color={TypographyColor.white}>
              Срок действия предложения: <span>{actionEnds}</span>
            </Typography>
          </>
        )}

        {step === 'accepted' && (
          <>
            <Typography type={TypographyType.h4} color={TypographyColor.white} className={styles.userRequest}>
              {fullName}, присоединяйся к команде
            </Typography>

            <Typography className={styles.scheduledText} type={TypographyType.h5} color={TypographyColor.white}>
              Дата первого рабочего дня: <span>{formattedSelectedDate}</span>
            </Typography>
          </>
        )}

        {step === 'rejected' && (
          <>
            <Typography type={TypographyType.h4} color={TypographyColor.white} className={styles.userRequest}>
              {fullName}
            </Typography>

            <Typography className={styles.rejectedText} type={TypographyType.h5} color={TypographyColor.white}>
              Нам жаль, что вы не стали частью нашей команды.
            </Typography>
          </>
        )}
      </Spacing>
    </Card>
  );
};
